import {registerPolyfills} from "./Utils/Polyfills";
import {Logger} from "./Utils/Logger";

export function libraryInitialize() {
    Logger.debugGroup('Library "neo-common"', 'Initialization started');
    registerPolyfills();

    (Promise as any).config({
        longStackTraces: DEBUG === true
    });

    Logger.debugGroup('Library "neo-common"', 'Initialization ends.');
}


/** WEBPACK FOOTER **
 ** ./Engine/bootstrap.ts
 **/